import { render } from "./Block.vue?vue&type=template&id=24b61e56&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=24b61e56&scoped=true&lang=css"

import exportComponent from "/Users/davidmihoc/Documents/LVJS2/reaction-timer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b61e56"]])

export default __exports__